import request from '@/utils/request'
// 服务条款以及通知内容接口 （未点同意的内容）
export function serviceRules(data) {
  return request({
    url: '/index_service_rules',
    method: 'post',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    data
  });
}
// 獲取電話
export function servicePhone(data) {
  return request({
    url: '/get_contact_tell',
    method: 'post',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    data
  });
}
// 修改電話
export function UpdatePhone(data) {
  return request({
    url: '/update_contact_tell',
    method: 'post',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    data
  });
}
// 服务条款以及通知确认同意接口（客户点击确认）
export function consentService(data) {
  return request({
    url: '/index_service_rules_clickok',
    method: 'post',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    data
  });
}
// 清空客户点击确认记录（用于测试）
export function cancelService(data) {
  return request({
    url: '/index_service_rules_clickok_cancel',
    method: 'post',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    data
  });
}
// 通告内容列表接口（返回list）
export function noticeRules(data) {
  return request({
    url: '/bulletin_board',
    method: 'post',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    data
  });
}
// 通告内容修改接口
export function updateNotice(data) {
  return request({
    url: '/update_bulletin_board',
    method: 'post',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    data
  });
}
// 通告内容新增接口
export function createNotice(data) {
  return request({
    url: '/new_bulletin_board',
    method: 'post',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    data
  });
}
// 通告内容刪除接口
export function deleteNotice(data) {
  return request({
    url: '/cancel_bulletin_board',
    method: 'post',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    data
  });
}
// 服務條款修改接口
export function updateService(data) {
  return request({
    url: '/update_service_rules',
    method: 'post',
    headers: {'Content-type': 'application/json;charset=UTF-8'},
    data
  });
}
